import { TotalPayment } from 'containers/SettlementRequestList/graphQL/types';
import { PageInfo } from 'types/api';

export interface Settlement {
  settlement: { settlements: Settlements };
}

export interface Settlements {
  edges: SettlementsEdges[];
  totalCount: number;
  pageInfo: PageInfo;
}

export interface SettlementsEdges {
  node: SettlementsNode;
}

export interface SettlementsAccountEdges {
  node: SettlementAccountNode;
}

export interface SettlementsNode {
  id: string;
  createdAt: string;
  startedDate: string;
  endedDate: string;
  title: string;
  periodCode: string;
  totalFee: {
    currencyCode: string;
    value: string;
  };
  totalPayment: {
    currencyCode: string;
    value: string;
  };
  invoice: Invoice;
}

export interface Invoice {
  id: string;
  title: string;
  status: InvoiceState;
  createdAt: string;
  completedAt: string;
  feeForReceivable: TotalPayment;
}

export enum InvoiceState {
  CANCELLED = 'CANCELLED', // 지급 취소
  COMPLETED = 'COMPLETED', // 지급 완료
  DRAFT_COMPLETED = 'DRAFT_COMPLETED', // 지급 진행 중
  FAILED = 'FAILED', // 지급 실패
  PROGRESSING = 'PROGRESSING', // 지급 진행 중
  READY = 'READY', // 지급 진행 중
  RECEIVED = 'RECEIVED', // 회수 완료
  RECEIVE_REQUESTED = 'RECEIVE_REQUESTED', // 회수 요청
}

export interface SettlementAccountNode extends SettlementsNode {
  payment: {
    currencyCode: string;
    value: string;
  };
  commissionFee: {
    currencyCode: string;
    value: string;
  };
  order: {
    id: string;
    customer: { nickname: string };
    transactions: { firmedAt: string }[];
  };
  orderItem: {
    id: string;
    info: { name: string };
    transaction: {
      firmedAt: string;
      order: {
        id: string;
        customer: { nickname: string };
        transactions: { firmedAt: string }[];
      };
    };
  };
  product: {
    listingProductV4: { title: string };
    options: { names: string[] }[];
  };
  type: SettlementAccountType;
  referredType: AccountReferredType;
  settlement: {
    id: string;
    totalFee: {
      currencyCode: CurrencyCode;
      value: number;
    };
  };
}

export interface SettlementAccount {
  settlement: {
    accounts: {
      totalCount: number;
      edges: SettlementsAccountEdges[];
      pageInfo: {
        hasNextPage: boolean;
      };
    };
  };
}

export enum SettlementAccountType {
  PAYABLE = 'PAYABLE',
  RECEIVABLE = 'RECEIVABLE',
}

export enum AccountReferredType {
  ABSENCE = 'ABSENCE',
  CANCEL_FEE = 'CANCEL_FEE',
  COUPON = 'COUPON',
  DIGITAL = 'DIGITAL',
  ETC = 'ETC',
  FRIP = 'FRIP',
  GOODS = 'GOODS',
}

enum CurrencyCode {
  KRW = 'KRW',
  USD = 'USD',
}
